<template>
  <div class="reservation-page">
    <!-- 标题区域 -->
    <div class="page-header">
      <h2 class="title">{{ downTitle ? '下载资料' : '预约服务' }}</h2>
      <p class="required-tip">*所有信息为必填</p>
    </div>

    <!-- 表单区域 -->
    <form class="reservation-form">
      <!-- 第一行：联系人 + 单位 -->
      <div class="form-row">
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>联系人</label>
          <input type="text" placeholder="请输入联系人" class="form-input" v-model="formData.contact"
            oninput="value=value.replace(/[^\u4e00-\u9fa5a-zA-Z]/g,'')" />
          <div class="error-tip">{{ formError.contact }}</div>
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>单位</label>
          <input type="text" placeholder="请输入单位" class="form-input" v-model="formData.company"
            oninput="value=value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g,'')" />
          <div class="error-tip">{{ formError.company }}</div>
        </div>
      </div>

      <!-- 第二行：职位 -->
      <div class="form-item full-width">
        <label class="form-label"><span class="required">*</span>职位</label>
        <input type="text" placeholder="请输入职位" class="form-input" v-model="formData.position"
          oninput="value=value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g,'')" />
        <div class="error-tip">{{ formError.position }}</div>
      </div>

      <!-- 新增：手机号（仅 downTitle 为 true 显示） -->
      <div class="form-item full-width">
        <label class="form-label"><span class="required">*</span>手机号</label>
        <input type="text" placeholder="请输入手机号" class="form-input" v-model="formData.phone"
          oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" />
        <div class="error-tip">{{ formError.phone }}</div>
      </div>

      <!-- 沟通问题（多行输入） -->
      <div class="form-item full-width">
        <label class="form-label"><span class="required">*</span>您想与售前沟通的问题</label>
        <textarea placeholder="请输入沟通问题" class="form-textarea" v-model="formData.question"></textarea>
        <div class="error-tip">{{ formError.question }}</div>
      </div>

      <!-- 提交按钮 -->
      <button type="button" class="submit-btn" @click="submitForm">{{ downTitle ? '立即下载' : '立即预约' }} →</button>
    </form>
  </div>
</template>

<script>
import { rsaEncrypt } from '@/utils/rsa'
import { downloadDoc, } from '@/utils'
export default {
  props: {
    downTitle: String,
  },
  data() {
    return {
      formData: {
        contact: '',
        company: '',
        position: '',
        email: '',
        question: '',
        phone: ''
      },
      formError: {
        contact: '',
        company: '',
        position: '',
        email: '',
        question: '',
        phone: ''
      }
    };
  },

  mounted() {
    if (this.$route.query.inputName) {
      this.formData.phone = this.$route.query.inputName;
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    validateForm() {
      this.formError = { contact: '', company: '', position: '', email: '', question: '', phone: '' };
      let isPass = true;
      const { contact, company, position, email, question, phone } = this.formData;

      if (!contact) {
        this.formError.contact = '请填写联系人姓名';
        isPass = false;
      }
      if (!company) {
        this.formError.company = '请填写所属单位';
        isPass = false;
      }
      if (!position) {
        this.formError.position = '请填写您的职位';
        isPass = false;
      }
      if (!question) {
        this.formError.question = '请填写您想沟通的问题或需求';
        isPass = false;
      }

      // downTitle 为 true 时校验手机号
      if (this.downTitle) {
        if (!phone) {
          this.formError.phone = '请填写手机号';
          isPass = false;
        } else if (!/^1[3-9]\d{9}$/.test(phone)) {
          this.formError.phone = '请输入正确的手机号';
          isPass = false;
        }
      }

      return isPass;
    },

    async submitForm() {
      const valid = this.validateForm();
      if (!valid) return;

      const mailContent = `
        联系人：${this.formData.contact}
        单位：${this.formData.company}
        职位：${this.formData.position}
        需求：${this.formData.question}
        手机号:${this.formData.phone}
      `;
      let title = this.downTitle ? `下载资料` : '官网预约'
      try {
        const result = await this.sendMail({
          title: rsaEncrypt(`【${title}】`),
          content: rsaEncrypt(mailContent)
        });
        if (this.downTitle) {
          downloadDoc(this.downTitle)
        }
        this.$message({ message: result.data, type: 'success' });
        this.goBack()

      } catch (err) {
        this.$message({ message: err, type: 'error' });
      }
    },

    async sendMail(data) {
      const url = `http://1.95.48.116:30119/msg/message/mail/website/send`
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      return await res.json();
    },
  }
};
</script>

<style lang="less" scoped>
// 页面所有非输入框元素 彻底无光标、无焦点、无选中框
*:not(input):not(textarea) {
  cursor: default;
  outline: none !important;
  border: none !important;
  caret-color: transparent !important;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
  box-shadow: none !important;
}

/* 页面整体样式 */
.reservation-page {
  background-color: #333;
  color: #fff;
  padding: 50px 200px;
  min-height: 100vh;
  position: relative;
}

/* 标题区域 */
.page-header {
  margin-bottom: 40px;
  max-width: 800px;
  margin: 50px auto;

  .title {
    font-size: 32px;
    margin-bottom: 10px;
    font-weight: normal;
  }

  .required-tip {
    font-size: 14px;
    color: #999;
  }
}

/* 表单区域 */
.reservation-form {
  max-width: 800px;
  margin: 0 auto;

  .form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
  }

  .form-item {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .form-label {
    font-size: 14px;
    color: #fff;

    .required {
      color: #f00;
      margin-right: 4px;
    }
  }

  .form-input {
    background-color: #000;
    border: none !important;
    outline: none !important;
    color: #fff;
    padding: 15px 20px;
    font-size: 16px;
    caret-color: #fff !important;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    box-shadow: none !important;

    &::placeholder {
      color: #999;
      opacity: 1;
    }

    &:focus {
      background-color: #000;
    }
  }

  .form-textarea {
    background-color: #000;
    border: none !important;
    outline: none !important;
    color: #fff;
    padding: 15px 20px;
    font-size: 16px;
    min-height: 100px;
    resize: none;
    caret-color: #fff !important;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    box-shadow: none !important;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    &::placeholder {
      color: #999;
      opacity: 1;
    }

    &:focus {
      background-color: #000;
    }
  }

  .error-tip {
    font-size: 12px;
    color: #ff4444;
    height: 14px;
    line-height: 14px;
    padding-left: 20px;
  }

  .submit-btn {
    background-color: transparent;
    border: 1px solid #fff !important;
    color: #fff;
    padding: 12px 30px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
    transition: background-color 0.2s;
    border-radius: 0;
    outline: none !important;
    box-shadow: none !important;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &:focus {
      background-color: transparent;
    }
  }
}


@media @mobile {
  .reservation-page {
    padding: 30px 16px;
    min-height: auto;
  }

  .page-header {
    margin: 0 0 30px;

    .title {
      font-size: 24px;
    }

    .required-tip {
      font-size: 12px;
    }
  }

  .reservation-form {
    .form-row {
      flex-direction: column;
      gap: 15px;
    }

    .form-item {
      gap: 4px;
    }

    .form-label {
      font-size: 13px;
    }

    .form-input,
    .form-textarea {
      padding: 12px 16px;
      font-size: 14px;
    }

    .form-textarea {
      min-height: 80px;
    }

    .error-tip {
      padding-left: 4px;
      font-size: 11px;
    }

    .submit-btn {
      width: 100%;
      padding: 14px;
      font-size: 15px;
      text-align: center;
    }
  }
}
</style>